import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { BaseProvider } from '@vwpfs/mary-air-lib/components/air/03-base/Base';
import { Themes } from '@vwpfs/mary-air-lib/theme/_Types';
import { I18nLanguage } from '@vwpfs/mary-air-lib/utils/translations/I18n';

import '@vwpfs/mary-air-lib/assets/stylesheets/themes/vwpfs/air/root';
import '@vwpfs/mary-air-lib/assets/stylesheets/themes/vwpfs/air/main';
import '@vwpfs/mary-air-lib/assets/stylesheets/themes/vwpfs/air/fonts';

import { getKeycloak, getKeycloakInitOptions } from './auth/keycloak';
import { App } from './App';
import { appEnv } from './lib/env';
import './styles/index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

const authClient = getKeycloak();

async function onKeycloakEvent(event: string): Promise<void> {
  if (event !== 'onTokenExpired' && event !== 'onAuthError') {
    return;
  }

  if (event === 'onTokenExpired') {
    try {
      const refreshed = await authClient.updateToken(50);

      if (!refreshed || !authClient.token) {
        authClient.clearToken();
        await authClient.logout({ redirectUri: appEnv.appUrl || globalThis.location.origin });
      }
    } catch {
      authClient.clearToken();
      await authClient.logout({ redirectUri: appEnv.appUrl || globalThis.location.origin });
    }

    return;
  }

  authClient.clearToken();
  await authClient.logout({ redirectUri: appEnv.appUrl || globalThis.location.origin });
}

createRoot(rootElement).render(
  <ReactKeycloakProvider
    authClient={authClient}
    initOptions={getKeycloakInitOptions()}
    onEvent={(event) => {
      void onKeycloakEvent(event);
    }}
  >
    <StrictMode>
      <BaseProvider theme={Themes.VWPFS} language={I18nLanguage.ENGLISH}>
        <App />
      </BaseProvider>
    </StrictMode>
  </ReactKeycloakProvider>
);
